<ng-container *notInPopulation="[populations.Suite, populations.Pts]">
  <fgb-banner [title]="'earn.page.title' | translate"></fgb-banner>
  <div class="d-block d-lg-none">
    <fgb-page-header
      [pageTitle]="'earn.page.title'"
      [backButtonLink]="'/'"
      [showBalance]="false"
      [showQr]="false"
    ></fgb-page-header>
  </div>

  <div class="container tier-progress-container">
    <div class="d-flex flex-column gap-2">
      <h2 class="tier-progress-tier mb-0">{{ 'tier.progress.title' | translate }}</h2>
      <p class="tier-progress-description mb-0">{{ 'tier.progress.description' | translate }}</p>
    </div>

    <div class="tier-progress-bar">
      <div class="progress-line"></div>
      <div class="tier-progress-bar-item">
        <img class="milestone-check" src="assets/images/tier-logo/qualified-check-circle.png" />
        <div class="progress-item-content">
          <img src="assets/images/tier-logo/tier_text_pro.svg" alt="" class="milestone-img" />
          <p class="milestone-point text-tertiary">{{ 'pro.milestone.point' | translate }}</p>
        </div>
      </div>
      <div class="tier-progress-bar-item">
        <img class="milestone-check" *ngIf="!checkEligible(tierLevel.AllStar)" src="assets/images/tier-logo/check-circle.png" />
        <img
          class="milestone-check"
          *ngIf="checkEligible(tierLevel.AllStar)"
          src="assets/images/tier-logo/qualified-check-circle.png"
        />
        <div class="progress-item-content">
          <img src="assets/images/tier-logo/tier_text_all_star.svg" alt="" class="milestone-img" />
          <p class="milestone-point text-all-star">{{ 'all.star.milestone.point' | translate }}</p>
        </div>
      </div>
      <div class="tier-progress-bar-item">
        <img class="milestone-check" *ngIf="!checkEligible(tierLevel.Pro)" src="assets/images/tier-logo/check-circle.png" />
        <img
          class="milestone-check"
          *ngIf="checkEligible(tierLevel.Pro)"
          src="assets/images/tier-logo/qualified-check-circle.png"
        />
        <div class="progress-item-content">
          <img src="assets/images/tier-logo/tier_text_mvp.svg" alt="" class="milestone-img" />
          <p class="milestone-point text-mvp">{{ 'mvp.milestone.point' | translate }}</p>
        </div>
      </div>
      <div class="tier-progress-bar-item">
        <img class="milestone-check" *ngIf="!checkEligible(tierLevel.Legend)" src="assets/images/tier-logo/check-circle.png" />
        <img
          class="milestone-check"
          *ngIf="checkEligible(tierLevel.Legend)"
          src="assets/images/tier-logo/qualified-check-circle.png"
        />
        <div class="progress-item-content">
          <img src="assets/images/tier-logo/tier_text_legend.svg" alt="" class="milestone-img" />
          <p class="milestone-point text-legend">{{ 'legend.milestone.point' | translate }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <fgbcl-earn-points [svgColor]="'primary'"></fgbcl-earn-points>
  </div>
</ng-container>

<ng-container *inPopulation="[populations.Suite, populations.Pts]">
  <fgb-not-found-page></fgb-not-found-page>
</ng-container>
